import { JobType, PermissionNameUnionType } from '@api';
import { faQuestion, faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { usePermissionContext } from '@hypeit-gmbh/hypeit-ui-core';
import { ConfirmCheckbox } from './components';

type UnconfirmedItemPropsType = {
  jobType: JobType | null;
  permissionName: PermissionNameUnionType;
  isChecked: boolean;
  onCheckboxChange: (jobId: string, isChecked: boolean) => void;
  isEditingOwnUser: boolean;
};

export const UnconfirmedItem: React.FC<UnconfirmedItemPropsType> = ({
  jobType,
  permissionName,
  isChecked,
  onCheckboxChange,
  isEditingOwnUser,
}) => {
  const { hasPermission } = usePermissionContext<PermissionNameUnionType>();

  const hasPermissionToConfirm = hasPermission({
    permission: permissionName,
    action: 'READ',
  });

  const showTimesIcon = jobType === null;

  const isAllowedToConfirm = hasPermissionToConfirm || isEditingOwnUser;

  if (showTimesIcon)
    return (
      <FontAwesomeIcon icon={faTimes} color="var(--mantine-color-text-4)" />
    );

  if (!isAllowedToConfirm)
    return (
      <FontAwesomeIcon icon={faQuestion} color="var(--mantine-color-text-4)" />
    );

  return (
    <ConfirmCheckbox
      jobType={jobType}
      isChecked={isChecked}
      onCheckboxChange={onCheckboxChange}
    />
  );
};
